import { render } from "./EmployeesOnLeaveConfigModal.vue?vue&type=template&id=f92c82c4&scoped=true"
import script from "./EmployeesOnLeaveConfigModal.vue?vue&type=script&lang=js"
export * from "./EmployeesOnLeaveConfigModal.vue?vue&type=script&lang=js"

import "./EmployeesOnLeaveConfigModal.vue?vue&type=style&index=0&id=f92c82c4&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\hrportal\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f92c82c4"]])

export default __exports__